module.exports = __webpack_public_path__ + "static/media/flow_Trim_cropped.a2ac660d.mp4";